import Text from "@ui-kit/typography/Text/Text.web";

import FormControl from "@ui-kit/form/FormControl/FormControl.web";
import FormLabel from "@ui-kit/form/FormLabel/FormLabel.web";

import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "@shared/utils/internationalization";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import FormRow from "@ui-kit/form/FormRow/FormRow.web";
import Input from "@ui-kit/form/Input/Input.web";
import FormErrorMessage from "@ui-kit/form/FormErrorMessage/FormErrorMessage.web";
import { SearchAddressFormInputProps } from "./SearchAddressFormInput.props";

export default function SearchAddressFormInput(
  props: SearchAddressFormInputProps
) {
  const { t } = useTranslation("common");
  const form = useFormContext();
  const { inputId, title, placeholder, required, updateInput, titleProps } =
    props;

  return (
    <Flex direction="column" gap="2xs">
      <FormRow>
        <FormControl
          isInvalid={Boolean(form.formState.errors[inputId]?.message)}
        >
          <FormLabel htmlFor={inputId}>
            <Text fontSize="sm" color="font.dark" {...titleProps}>
              {title}
            </Text>
          </FormLabel>
          <Controller
            name={inputId}
            control={form.control}
            defaultValue=""
            rules={{
              required: required ? t("This field is required.") : false,
            }}
            render={({ field }) => (
              <Input
                {...field}
                id={inputId}
                data-testid={inputId}
                type="text"
                placeholder={placeholder}
                borderRadius="sm"
                onBlur={() => updateInput(inputId, field.value)}
                maxLength={100}
              />
            )}
          />
          <FormErrorMessage>
            {String(form.formState.errors[inputId]?.message)}
          </FormErrorMessage>
        </FormControl>
      </FormRow>
    </Flex>
  );
}
